import { Box, CardMedia, Grid, Typography } from '@mui/material';
import TemplateDefault from '../../layout/TemplateDefault';
import ImageHero from '../../images/secure_security_validation_pana.webp';
import AttendanceDeclarationForm from '../../components/pages/AttendanceDeclarationForm';
import { FullHeightOnlyCustom } from './styled';
import { useValidateAttendanceDeclarationMutation } from '../../services/schedule.service';
import Success from '../../components/pages/AttendanceDeclarationForm/Feedback/Success';
import Error from '../../components/pages/AttendanceDeclarationForm/Feedback/Error';
import { useState } from 'react';

export default function AttendanceDeclaration() {
  const [validateAttendanceDeclaration, { data, isLoading, error, reset }] = useValidateAttendanceDeclarationMutation();
  const [retrying, setRetrying] = useState(false);
  const onSubmit = async (formData: any) => {
    setRetrying(false);
    await validateAttendanceDeclaration({ code: formData.verification.code });
  };

  const retryCallback = () => {
    setRetrying(true);
    reset();
  };

  return (
    <TemplateDefault>
      {((!data && !error) || retrying) && (
        <FullHeightOnlyCustom container>
          <Grid xs={12} md={6} order={{ xs: 1, md: 2 }}>
            <Box sx={{ mb: 5 }}>
              <CardMedia component="img" alt="computador" image={ImageHero} sx={{ width: { xs: 200, md: '100%' } }} />
            </Box>
          </Grid>

          <Grid xs={12} md={6} order={{ xs: 2, md: 1 }}>
            <Typography variant="h2" sx={{ mb: 4 }}>
              Validação de documento
            </Typography>
            <Typography variant="body1R" sx={{ mb: 4 }}>
              Insira no campo abaixo o código para autenticar a Declaração de Comparecimento.
            </Typography>
            <AttendanceDeclarationForm onSubmit={onSubmit} loading={isLoading} />
          </Grid>
        </FullHeightOnlyCustom>
      )}
      {data && (
        <FullHeightOnlyCustom container sx={{ flexDirection: 'column', justifyContent: 'flex-start', gap: 0 }}>
          <Success data={data} />
        </FullHeightOnlyCustom>
      )}
      {error && (
        <FullHeightOnlyCustom container sx={{ flexDirection: 'column', justifyContent: 'flex-start', gap: 0 }}>
          <Error errorCallback={retryCallback} />
        </FullHeightOnlyCustom>
      )}
    </TemplateDefault>
  );
}
